import Honeybadger from '@honeybadger-io/js';

export default class AjaxFailureNotifier {
  init() {
    $(document).ajaxError((event, request, settings) => {
      if (request.status === 400) return;

      Honeybadger.notify(
        `AJAX ${request.status || 'network'} ${settings?.type || ''} ${settings?.url || ''}`.trim(),
        {
          name: 'AjaxError',
          context: {
            url: settings?.url,
            method: settings?.type,
            status: request.status,
            statusText: request.statusText,
            response_excerpt: typeof request.responseText === 'string'
              ? request.responseText.slice(0, 500)
              : null
          }
        }
      );
    });
  }
}
